
export default [
    {
        path: '/ia',
        component: "__base",
        otherdata: { color: "primary" },
        children: [
            {
                // module: "TDS",
                path: "project",
                component: "ProjectList.vue",
                meta: { title: "Project List" },
            },
            {
                // module: "TDS",
                path: "view/:projectid",
                component: "ViewProject.vue",
                meta: { title: "View Project" },
            },
            {
                // module: "TDS",
                path: "*",
                component: "",
            },
        ],
    },
]

